import { render, staticRenderFns } from "./serving-contact-user-search-drawer.vue?vue&type=template&id=057c83bb&"
import script from "./serving-contact-user-search-drawer.vue?vue&type=script&lang=js&"
export * from "./serving-contact-user-search-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports